export enum UserPermission {
    // Grant/Revoke Permissions
    GrantCanReceiveOffer = 'GrantCanReceiveOffer',
    RevokeCanReceiveOffer = 'RevokeCanReceiveOffer',
    GrantSearchLeadAudit = 'GrantSearchLeadAudit',
    RevokeSearchLeadAudit = 'RevokeSearchLeadAudit',
    GrantInterdictUser = 'GrantInterdictUser',
    RevokeInterdictUser = 'RevokeInterdictUser',
    GrantResumeUser = 'GrantResumeUser',
    RevokeResumeUser = 'RevokeResumeUser',

    // Lead Permissions
    AcceptAssignationOfferOnBehalf = 'AcceptAssignationOfferOnBehalf',
    RefuseAssignationOfferOnBehalf = 'RefuseAssignationOfferOnBehalf',
    SearchLead = 'SearchLead',
    SearchLeadHistory = 'SearchLeadHistory',
    SearchLeadAudit = 'SearchLeadAudit',
    SearchHierarchyLead = 'SearchHierarchyLead',
    SearchAnyLead = 'SearchAnyLead',
    CreateLead = 'CreateLead',
    EditLead = 'EditLead',
    EditAnyLead = 'EditAnyLead',
    QualifyAnyLead = 'QualifyAnyLead',
    DeleteLead = 'DeleteLead',
    DeleteAnyLead = 'DeleteAnyLead',
    EditInheritedLead = 'EditInheritedLead',

    // User Permissions
    Login = 'Login',
    SearchUser = 'SearchUser',
    SearchAnyUser = 'SearchAnyUser',
    SearchUserAudit = 'SearchUserAudit',
    InterdictAnyUser = 'InterdictAnyUser',
    InterdictUser = 'InterdictUser',
    ResumeAnyUser = 'ResumeAnyUser',
    ResumeUser = 'ResumeUser',
    CanReceiveOffer = 'CanReceiveOffer',
    DeleteAnyBusinessSector = 'DeleteAnyBusinessSector',
    EditAnyUser = 'EditAnyUser',
    GrantViewAnyLead = 'GrantViewAnyLead',
    OfferOrAssignLead = 'OfferOrAssignLead',
    OfferOrAssignLeadsToAnyAgent = 'OfferOrAssignLeadsToAnyAgent',
    RecoverAnyDeletedBusinessSector = 'RecoverAnyDeletedBusinessSector',
    RevokeAnyLeadOfferOrAssignation = 'RevokeAnyLeadOfferOrAssignation',
    RevokeLeadOfferOrAssignation = 'RevokeLeadOfferOrAssignation',
    RevokeViewAnyLead = 'RevokeViewAnyLead',
    ViewAnyDeletedBusinessSector = 'ViewAnyDeletedBusinessSector',
    ViewAnyLead = 'ViewAnyLead',
    ViewHealthCheck = 'ViewHealthCheck',
    ViewInheritedLead = 'ViewInheritedLead',
    ViewLead = 'ViewLead',
    EditAnyBusinessSector = 'EditAnyBusinessSector',

    // Lead Injector Permissions
    ViewLeadInjector = 'ViewLeadInjector',
    SearchLeadInjector = 'SearchLeadInjector',
    CreateLeadInjector = 'CreateLeadInjector',
    EditLeadInjector = 'EditLeadInjector',
    DeleteLeadInjector = 'DeleteLeadInjector',

    // Social Forms Permissions
    CreateFacebookFormConfig = 'CreateFacebookFormConfig',
    DeleteFacebookFormConfig = 'DeleteFacebookFormConfig',
    DeleteFacebookLogs = 'DeleteFacebookLogs',
    EditFacebookFormConfig = 'EditFacebookFormConfig',
    ViewFacebookFormConfig = 'ViewFacebookFormConfig',
    ViewFacebookLogs = 'ViewFacebookLogs'
}